import React from 'react'
// import './SearchResultsCard.scss'
import { GeneralDocument, Hits } from '../../models'
import imageRatio from '../../assets/image_ratio.png'
import { clickSuggestionListItem } from '../../datalayerEvent'
import { BrandPlaceholderImage, resultDetailLinkText } from '../../Common'

const SearchResultCard = ({ data }: { data: Hits<GeneralDocument> }) => {
  const handleClick = () => {
    const url = data?._source?.url?.[0]
    if (url) {
      clickSuggestionListItem(data?._source?.title?.[0])
      // window.location.href = url // Open the link in the same tab
    }
  }
  return (
    // eslint-disable-next-line react/no-unknown-property
    <div className='col-md-6 col-sm-12 col-lg-8 col-xl-6' large-card=''>
      <div
        className='card-article card-article--lg card-article--light'
        data-animation='fadeInUp'
        onClick={handleClick}
      >
        <div>
          <a href={data?._source?.url?.[0]} className='card-article__coverlink'></a>

          <div className='card-article__header-container'>
            <div className='tags__container'>
              <div className='card-article__topic'>
                {' '}
                {Array.isArray(data?._source?.content_type) &&
                ['news', 'product', 'cocktails', 'cocktail'].includes(
                  data?._source?.content_type?.[0]?.toLowerCase()
                )
                  ? data?._source?.content_type?.[0]
                  : 'page'}
              </div>
            </div>
            <div className='card-article__title'>{data?._source?.title?.[0]}</div>
            <div className='card-article__description'>
              {data?.highlight?.rendered_item?.map(
                (item: string, index: React.Key | null | undefined) => (
                  <p key={index} dangerouslySetInnerHTML={{ __html: item }} />
                )
              )}
              {/* Laphroaig has released The Wall Collection */}
            </div>
          </div>
          <div className='card-article__footer-container'>
            <div className='card-article__learn-more'>
              <a href={data?._source?.url?.[0]} className='btn btn--tertiary-positive'>
                <span>{resultDetailLinkText}</span>
                <i className='icons chevron-right'></i>
              </a>
            </div>
          </div>
          <div className='bs-responsive-image-holder'>
            <picture className='card-article__bg-img-container' data-animation='zoomOut'>
              <source
                srcSet={
                  data?._source?.image?.[0]
                    ? data?._source?.image?.[0]
                    : BrandPlaceholderImage
                      ? BrandPlaceholderImage
                      : imageRatio
                }
                type='image/webp'
                media='(min-width:1025px)'
              />
              <img
                src={
                  data?._source?.image?.[0]
                    ? data?._source?.image?.[0]
                    : BrandPlaceholderImage
                      ? BrandPlaceholderImage
                      : imageRatio
                }
                alt=''
                title=''
              />
            </picture>

            {/* <picture className="card-article__bg-img-container" data-animation="zoomOut">
              <source srcSet="https://dev-bs-whitelabel.sites-beamsuntory.com/themes/custom/bsi_tokens_theme/demo-php/assets/images/cards/article/large-bg.png" type="image/webp" media="(min-width:1025px)" />
              <img src="https://dev-bs-whitelabel.sites-beamsuntory.com/themes/custom/bsi_tokens_theme/demo-php/assets/images/cards/article/small-bg-light.png" alt="" title="" />
            </picture> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchResultCard
